import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  gridRow: {
    minHeight: 60,
    borderBottom: '1px solid #E0E0E0',
    padding: spacing(1, 0),
    '&::before': {
      content: 'close-quote',
      position: 'absolute',
      borderRadius: spacing(0, 2, 2, 0),
      width: spacing(0.75),
      height: spacing(3.75),
      backgroundColor: '#4083f7'
    },
    '&:hover': {
      backgroundColor: palette.background.selected || 'rgba(0, 0, 0, 0.04)'
    }
  },
  titleColumn: {
    padding: spacing(0, 2.5, 0, 3)
  },
  cardImage: {
    width: 40,
    height: 40,
    borderRadius: 4,
    marginRight: spacing(2),
    float: 'left',
    objectFit: 'cover'
  },
  noImageIconWrapper: {
    float: 'left',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    marginRight: '16px',
    padding: spacing(1.2, 1.5),
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    color: palette.text.disabled,
    '& svg': {
      marginTop: 3
    }
  },
  actionsColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: spacing(1),
    paddingRight: spacing(1)
  }
}))
